import { BaseModel } from "../base.model";

export class DocumentType extends BaseModel {
  id: number;
  name: string;
  description: string;
}
